import { Component, OnInit } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { UigNewsConnector } from '../uig-news.connector';
import { UigCmsNewsWidgetComponent, UigNewsItem } from '../uig-news.model';

@Component({
    selector: 'app-uig-news-widget',
    templateUrl: './uig-news-widget.component.html',
    styleUrls: ['./uig-news-widget.component.scss'],
    standalone: false
})
export class UigNewsWidgetComponent implements OnInit {

  public news$ = new BehaviorSubject<UigNewsItem[]>(undefined);
  newsPageUrl : string;

  public subscription: Subscription;
  private maxShownItems: string;
  private title: string;

  public componentData$: Observable<UigCmsNewsWidgetComponent> = this.componentData.data$;

  constructor(
    protected componentData: CmsComponentData<UigCmsNewsWidgetComponent>,
    private uigNewsCnn: UigNewsConnector,
    private baseSiteService: BaseSiteService,
  ) {}

  ngOnInit(): void {
    this.getMaxShownItems();
    this.fetchNews();
    this.baseSiteService.getActive().subscribe((data) =>{
      this.newsPageUrl = data + '/news';
    })
  }

  private getMaxShownItems(): void {
    this.subscription = this.componentData.data$
      .subscribe((data) => {
        this.maxShownItems = data.maxShownItems;
        this.title = data.name;
      });
  }

  private fetchNews(): void {
    // Unsubscribe is not required since this it's an HTTP call which will get unsubscribed automatically
    this.uigNewsCnn
      .getNews()
      .pipe(
        filter(Boolean),
        tap(
          (newsItems: UigNewsItem[]) => newsItems.splice(parseInt(this.maxShownItems) + 1)
        )
      )
      .subscribe((news) => {
        this.news$.next(news);
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
